import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import SimpleButton from '../../../components/Buttons/SimpleButton/SimpleButton';
import { FOLLOW_UP } from '../../WorkLog/workLogConstants';
import NOB from '../../../constants/language-strings';
import Color from '../../../components/Buttons/Color';
function WorkOrderCompletionButtons({ disabled, handleSubmit, technician, values, disableCompleteButton, disableNotCompleteButton, }) {
    return (_jsx("div", { children: technician ? (_jsx(SimpleButton, { onClick: () => {
                handleSubmit(!values[FOLLOW_UP]);
            }, disabled: disabled, title: NOB.CUSTOMER_NOT_HOME.REPORT })) : (_jsxs("div", { className: "complete__workorder__container--buttons", children: [_jsx(SimpleButton, { onClick: () => {
                        handleSubmit(false);
                    }, disabled: disabled || disableNotCompleteButton, color: Color.RED, title: NOB.WORK_LOG.NOT_COMPLETE_BUTTON }), _jsx(SimpleButton, { onClick: () => {
                        handleSubmit(true);
                    }, disabled: disabled || disableCompleteButton, color: Color.YELLOW, title: NOB.WORK_LOG.COMPLETE_BUTTON })] })) }));
}
WorkOrderCompletionButtons.propTypes = {
    disabled: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    technician: PropTypes.bool.isRequired,
    values: PropTypes.objectOf(PropTypes.any).isRequired,
    disableCompleteButton: PropTypes.bool,
    disableNotCompleteButton: PropTypes.bool,
};
WorkOrderCompletionButtons.defaultProps = {
    disableCompleteButton: false,
    disableNotCompleteButton: false,
};
export default WorkOrderCompletionButtons;
